import { Component, OnInit, ViewChild, TemplateRef, inject } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { UserDetails } from '../../../interfaces/user.interface';
import { Router, RouterModule } from '@angular/router';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CommonModule } from '@angular/common';
import { ENROLLMENT_TYPE_BACKEND_MAPPINGS, STATIC_DATA } from '../../../shared/constants/static-data.constants';
import { LookupService } from '../../../services/lookup.service';
import { ReferralDataService } from '../../../services/referral-data.service';
import { SectionsService } from '../../../services/sections.service';
import {
  DialogConfig,
  DialogService,
} from '../../../shared/services/dialog.service';
import { MemberViewComponent } from "../../lead-details/member-wrapper-view/member-wrapper-view";
import { LeadDetailsService } from '../../../services/lead-details.service';

@Component({
  selector: 'ppl-home',
  standalone: true,
  imports: [
    RouterModule,
    NzLayoutModule,
    NzIconModule,
    CommonModule,
    MemberViewComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit {

  userDetails: UserDetails | undefined;
  isCollapsed = false;
  numberOfLinks = 1;
  viewUserShowAllTabs = false;
  private dialogSvc = inject(DialogService);
  @ViewChild('authDialog') authDialog!: TemplateRef<any>;

  constructor(
    private userService: UserService,
    private router: Router,
    private lookupService: LookupService,
    private sectionService: SectionsService,
    private referralDataService: ReferralDataService,
    private leadDetailsService: LeadDetailsService,
  ) { }

  ngOnInit() {
    this.userDetails = this.userService.getUserDetails();

    // Fetch lookup values and store them in-memory
    this.lookupService.fetchAndStoreLookupValues();

    const program = this.userService.getSelectedProgram();
    if (program?.program_code !== STATIC_DATA.LEAD_PROGRAM) {
      // Fetch and store TAS and provider type lookup values in-memory
      this.lookupService.fetchAndStoreTasLookupValues();
      this.lookupService.fetchAndStoreProviderTypeLookupValues();
    }

    this.handleUserViewNavigation();
  }

  onLinkSelect = (link: string) => {
    this.router.navigateByUrl(`/home/${link}`);
  }

  handleUserViewNavigation() {
    this.userService.viewUserEvent.subscribe((event: any) => {
      this.viewUserShowAllTabs = !!event.showAllTabs;
      if (event.isConsumer) {
        this.navigateToParticipant(event.userId);
      } else {
        this.navigateToProvider(event.userId);
      }
    });
  }

  navigateToParticipant(userId: string) {
    this.userService.setFirstSegment(STATIC_DATA.PARTICIPANT_ENROLLMENT_LIST);
    this.userService.setLeadEntry('participantEnrollment');
    this.sectionService.setFlow('participantEnrollment');
    this.referralDataService.clearReferrralData();
    this.sectionService.setEnrollmentType(JSON.stringify([]));

    this.userService.setSelectedLead(userId);
    this.openAuthDialog('');
  }


  navigateToProvider(providerID: number) {
    const program = this.userService.getSelectedProgram();
    this.userService.setFirstSegment(STATIC_DATA.PROVIDER_ENROLLMENT_LIST);
    this.userService.setLeadEntry('providerEnrollment');
    this.sectionService.setFlow('providerEnrollment');
    this.referralDataService.clearReferrralData();

    this.userService.setSelectedLead(providerID + '');

    this.leadDetailsService
      .fetchLeadDetailsApi(
        'providerEnrollment',
        program ? program.program_code : '',
        providerID
      )
      .subscribe((data: any) => {
        console.log(data.responsedata);
        if (data.responsedata) {
          const basicInfo = data.responsedata.basicInfo;
          const entrollmentType = ENROLLMENT_TYPE_BACKEND_MAPPINGS[basicInfo.providerType];
          this.sectionService.setEnrollmentType(JSON.stringify([entrollmentType]));
          this.openAuthDialog(basicInfo.fname + ' ' + basicInfo.lname);
        }
      });
  }

  openAuthDialog(userName: string) {
    const dialogConfig: DialogConfig = {
      title: `User Details for ` + userName,
      okText: 'Deny',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.authDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  handleCancel() {
    //todo: handle after closing popup, may be clear the data
  }
}